module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/9200459659/particular02-f557f4c4849655d386d8fbd42dec8256.png";